import { render, staticRenderFns } from "./cardQuota.vue?vue&type=template&id=02810e7c&"
import script from "./cardQuota.vue?vue&type=script&lang=js&"
export * from "./cardQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports